import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './index.module.scss'
import { Affix } from '@alifd/next'
import { logo } from 'portal/assets/images/index'

interface NavItem {
  name: string;
  link: string;
  children?: NavItem[];
}

export default function Header() {
  const operateSpace: NavItem[] = [
    {
      name: '控制台',
      link: '/admin',
      children: [
        {
          name: '数据元管理系统',
          link: '/apps/metadata',
        },
        {
          name: '数据标准验证和转换系统',
          link: '/apps/metadata?name=eincradle',
        }
      ]
    },
    {
      name: '注册',
      link: '/register',
    },
    {
      name: '登录',
      link: '/exteriorFacade', // TODO: 登录之后到外立面页面，暂时无登录，就放上外立面页面，后续修改
    }
  ]

  const dropDownNavs: NavItem[] = [
    {
      name: '平台首页',
      link: '/',
    },
    {
      name: '数据检索',
      link: '/apps/dsp?path=/search',
    },
    {
      name: '提出假设',
      link: '',
      children: [
        {
          name: '文献分析工具',
          link: '/apps/sdss',
        },
        {
          name: '方法学培训',
          link: '/apps/edu?path=/courses',
        },
        {
          name: '方法学门诊预约',
          link: 'https://ncrcrd.einmatrix.com/%E4%B8%AD%E5%BF%83%E4%BB%8B%E7%BB%8D/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/%E6%96%B9%E6%B3%95%E5%AD%A6%E9%97%A8%E8%AF%8A/',
        },
      ]
    },
    {
      name: '开展研究',
      link: '',
      children: [
        {
          name: '临床研究项目管理（CTMS）',
          link: '/apps/pm?path=/index.jsp?sysId=i',
        },
        {
          name: '伦理审批',
          link: '',
        },
        {
          name: '电子数据采集（EDC）',
          link: '/apps/edc',
        },
        {
          name: '生物样本库',
          link: '/apps/biobank',
        },
        {
          name: '在线统计分析',
          link: '/apps/sat',
        }
      ]
    },
    {
      name: '成果应用',
      link: '',
      children: [
        {
          name: '科研成果管理',
          link: '/apps/dsp?path=/studies',
        },
        {
          name: '预测模型系统',
          link: '/apps/cmt',
        },
        {
          name: '培训认证',
          link: '/apps/edu',
        },
        {
          name: '技术推广',
          link: 'https://ncrcrd.einmatrix.com/%E8%BD%AC%E5%8C%96%E6%8E%A8%E5%B9%BF/%E5%8C%BB%E8%81%94%E4%BD%93/',
        }
      ]
    },
    {
      name: '质控干预',
      link: '',
      children: [
        {
          name: '临床诊疗质控和科研转化系统',
          link: '/apps/qc?path=/center/1/index',
        },
        {
          name: '基层呼吸规范化建设',
          link: 'https://cqms.cardpc.org/m/',
        }
      ]
    },
    {
      name: '综合改善',
      link: '',
    }
  ]

  function operateSpaceNav(item: NavItem, index: number) {
    const { name, link, children } = item
    return (
      <div className={styles.operateSpace}>
        <NavLink to={link} style={{ lineHeight: '35px' }}>{ name }</NavLink>
        {index === 1 ? <span style={{ color: '#fff' }}>|</span> : ''}
        {children && <div className={styles.dropdown}>
          {children.map(dropDownNav)}
        </div>}
      </div>
    )
  }

  // 导航的下拉框
  function dropDownNav(item: NavItem) {
    const { name, link } = item
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">{name}</a>
    )
  }

  function TopNav(item: NavItem) {
    const { name, link, children } = item
    return (
      <div className={styles.navItem}>
        <a href={link} className={ styles.active }>{name}</a>
        {children && <div className={styles.dropdown}>
          {children.map(dropDownNav)}
        </div>
        }
      </div>
    )
  }

  return (
    <Affix offsetTop={0}>
      <div className={styles.navbar}>
        <div className={styles.topBar}>
          <div data-flex="cross:center" style={{ width: 1200, lineHeight: '35px', margin: '0 auto', justifyContent: 'space-between' }}>
            <div className={styles.leftTopbar}>
              <a href="https://ncrcrd.einmatrix.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }} >国家呼吸系统疾病临床医学研究中心</a>
              <a href="https://www.zryhyy.com.cn/" style={{ color: '#fff' }} target="_blank" rel="noopener noreferrer">中日友好医院</a>
            </div>
            <div data-flex="cross:center">
              {operateSpace.map(operateSpaceNav)}
            </div>
          </div>
        </div>
        <div className={styles.navbarContent} data-flex="main:justify cross:center">
          <div className={styles.logo}>
            <img src={logo} alt="logo" />
          </div>
          <div data-flex="cross:center">
            {dropDownNavs.map(TopNav)}
          </div>
        </div>
      </div>
    </Affix>
  )
}
